import { DomainError } from '@qrkey/contracts/errors';

/** Why an input could not be priced. Stable strings; callers may branch on them. */
export type PricingErrorReason =
  | 'INVALID_INPUT'
  | 'DUPLICATE_ID'
  | 'UNKNOWN_TAX_GROUP'
  | 'TAX_RULE_OVERLAP'
  | 'TAX_RULE_UNSPLITTABLE'
  | 'UNKNOWN_DISCOUNT_TARGET';

/**
 * A pricing input that cannot be priced (bad data or configuration). It is a
 * `DomainError('VALIDATION_FAILED')`, so the HTTP layer maps it to a 400
 * problem; `reason` says which rule failed.
 */
export class PricingError extends DomainError {
  readonly reason: PricingErrorReason;

  constructor(reason: PricingErrorReason, detail: string) {
    super('VALIDATION_FAILED', { detail: `${reason}: ${detail}` });
    this.name = 'PricingError';
    this.reason = reason;
  }
}
